import React from 'react';

import { styled } from '@mui/material';
import parse from 'html-react-parser';

import {
  BackButton,
  Buttons,
  ExplanationText,
  StyledChevronLeftIcon,
  SubmitButton,
  TitleWrapper,
} from '~/components/QuestionQuiz/styles';
import useTenantTranslation from '~/hooks/useTenantTranslation';

const QuestionExplainer = ({ title, explanation, hideArrowBackButton, goBack, colorsMode }) => {
  const { t } = useTenantTranslation();

  return (
    <>
      {!hideArrowBackButton && (
        <BackButton aria-label={t('button.close')} onClick={goBack}>
          <StyledChevronLeftIcon />
        </BackButton>
      )}
      <TitleWrapper>{title}</TitleWrapper>
      <ExplanationText colorsMode={colorsMode}>{parse(explanation)}</ExplanationText>
      <Buttons>
        <CloseButton colorsMode={colorsMode} data-testid="backToAnswers" onClick={goBack}>
          {t('button.close')}
        </CloseButton>
      </Buttons>
    </>
  );
};

export default QuestionExplainer;

const CloseButton = styled(SubmitButton)`
  ${({ theme }) => theme.breakpoints.up('md')} {
    margin-right: auto;
  }
`;
